/**
 * DevExtreme (localization/cldr-data/accounting_formats.js)
 * Version: 19.2.6
 * Build date: Thu Jan 30 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
"use strict";
module.exports = {
    af: "\xa4#,##0.00;(\xa4#,##0.00)",
    "af-NA": "\xa4#,##0.00;(\xa4#,##0.00)",
    agq: "#,##0.00\xa4",
    ak: "\xa4#,##0.00",
    am: "\xa4#,##0.00;(\xa4#,##0.00)",
    ar: "\xa4#,##0.00;(\xa4#,##0.00)",
    "ar-AE": "\xa4#,##0.00;(\xa4#,##0.00)",
    "ar-BH": "\xa4#,##0.00;(\xa4#,##0.00)",
    "ar-DJ": "\xa4#,##0.00;(\xa4#,##0.00)",
    "ar-DZ": "\xa4#,##0.00;(\xa4#,##0.00)",
    "ar-EG": "\xa4#,##0.00;(\xa4#,##0.00)",
    "ar-EH": "\xa4#,##0.00;(\xa4#,##0.00)",
    "ar-ER": "\xa4#,##0.00;(\xa4#,##0.00)",
    "ar-IL": "\xa4#,##0.00;(\xa4#,##0.00)",
    "ar-IQ": "\xa4#,##0.00;(\xa4#,##0.00)",
    "ar-JO": "\xa4#,##0.00;(\xa4#,##0.00)",
    "ar-KM": "\xa4#,##0.00;(\xa4#,##0.00)",
    "ar-KW": "\xa4#,##0.00;(\xa4#,##0.00)",
    "ar-LB": "\xa4#,##0.00;(\xa4#,##0.00)",
    "ar-LY": "\xa4#,##0.00;(\xa4#,##0.00)",
    "ar-MA": "\xa4#,##0.00;(\xa4#,##0.00)",
    "ar-MR": "\xa4#,##0.00;(\xa4#,##0.00)",
    "ar-OM": "\xa4#,##0.00;(\xa4#,##0.00)",
    "ar-PS": "\xa4#,##0.00;(\xa4#,##0.00)",
    "ar-QA": "\xa4#,##0.00;(\xa4#,##0.00)",
    "ar-SA": "\xa4#,##0.00;(\xa4#,##0.00)",
    "ar-SD": "\xa4#,##0.00;(\xa4#,##0.00)",
    "ar-SO": "\xa4#,##0.00;(\xa4#,##0.00)",
    "ar-SS": "\xa4#,##0.00;(\xa4#,##0.00)",
    "ar-SY": "\xa4#,##0.00;(\xa4#,##0.00)",
    "ar-TD": "\xa4#,##0.00;(\xa4#,##0.00)",
    "ar-TN": "\xa4#,##0.00;(\xa4#,##0.00)",
    "ar-YE": "\xa4#,##0.00;(\xa4#,##0.00)",
    as: "\xa4\xa0#,##,##0.00",
    asa: "#,##0.00\xa0\xa4",
    ast: "#,##0.00\xa0\xa4",
    az: "#,##0.00\xa0\xa4",
    "az-Cyrl": "#,##0.00\xa0\xa4",
    "az-Latn": "#,##0.00\xa0\xa4",
    bas: "#,##0.00\xa0\xa4",
    be: "#,##0.00\xa0\xa4",
    bem: "\xa4#,##0.00;(\xa4#,##0.00)",
    bez: "#,##0.00\xa4",
    bg: "0.00\xa0\xa4;(0.00\xa0\xa4)",
    bm: "\xa4#,##0.00;(\xa4#,##0.00)",
    bn: "#,##,##0.00\xa4;(#,##,##0.00\xa4)",
    "bn-IN": "#,##,##0.00\xa4;(#,##,##0.00\xa4)",
    bo: "\xa4\xa0#,##0.00",
    "bo-IN": "\xa4\xa0#,##0.00",
    br: "#,##0.00\xa0\xa4",
    brx: "\xa4\xa0#,##,##0.00",
    bs: "#,##0.00\xa0\xa4",
    "bs-Cyrl": "#,##0.00\xa0\xa4",
    "bs-Latn": "#,##0.00\xa0\xa4",
    ca: "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "ca-AD": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "ca-ES-VALENCIA": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "ca-FR": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "ca-IT": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    ccp: "#,##,##0.00\xa4;(#,##,##0.00\xa4)",
    "ccp-IN": "#,##,##0.00\xa4;(#,##,##0.00\xa4)",
    ce: "#,##0.00\xa0\xa4",
    ceb: "\xa4#,##0.00;(\xa4#,##0.00)",
    cgg: "\xa4#,##0.00",
    chr: "\xa4#,##0.00;(\xa4#,##0.00)",
    ckb: "\xa4\xa0#,##0.00",
    "ckb-IR": "\xa4\xa0#,##0.00",
    cs: "#,##0.00\xa0\xa4",
    cu: "\xa4\xa0#,##0.00",
    cy: "\xa4#,##0.00;(\xa4#,##0.00)",
    da: "#,##0.00\xa0\xa4",
    "da-GL": "#,##0.00\xa0\xa4",
    dav: "\xa4#,##0.00;(\xa4#,##0.00)",
    de: "#,##0.00\xa0\xa4",
    "de-AT": "#,##0.00\xa0\xa4",
    "de-BE": "#,##0.00\xa0\xa4",
    "de-CH": "#,##0.00\xa0\xa4",
    "de-IT": "#,##0.00\xa0\xa4",
    "de-LI": "#,##0.00\xa0\xa4",
    "de-LU": "#,##0.00\xa0\xa4",
    dje: "#,##0.00\xa4",
    dsb: "#,##0.00\xa0\xa4",
    dua: "#,##0.00\xa0\xa4",
    dyo: "#,##0.00\xa0\xa4",
    dz: "\xa4#,##,##0.00",
    ebu: "\xa4#,##0.00;(\xa4#,##0.00)",
    ee: "\xa4#,##0.00;(\xa4#,##0.00)",
    "ee-TG": "\xa4#,##0.00;(\xa4#,##0.00)",
    el: "#,##0.00\xa0\xa4",
    "el-CY": "#,##0.00\xa0\xa4",
    en: "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-001": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-150": "#,##0.00\xa0\xa4",
    "en-AE": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-AG": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-AI": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-AS": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-AT": "\xa4\xa0#,##0.00",
    "en-AU": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-BB": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-BE": "#,##0.00\xa0\xa4",
    "en-BI": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-BM": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-BS": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-BW": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-BZ": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-CA": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-CC": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-CH": "\xa4\xa0#,##0.00;\xa4-#,##0.00",
    "en-CK": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-CM": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-CX": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-CY": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-DE": "#,##0.00\xa0\xa4",
    "en-DG": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-DK": "#,##0.00\xa0\xa4",
    "en-DM": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-ER": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-FI": "#,##0.00\xa0\xa4",
    "en-FJ": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-FK": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-FM": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-GB": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-GD": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-GG": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-GH": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-GI": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-GM": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-GU": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-GY": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-HK": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-IE": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-IL": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-IM": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-IN": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-IO": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-JE": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-JM": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-KE": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-KI": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-KN": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-KY": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-LC": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-LR": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-LS": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-MG": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-MH": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-MO": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-MP": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-MS": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-MT": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-MU": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-MW": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-MY": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-NA": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-NF": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-NG": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-NL": "\xa4\xa0#,##0.00;(\xa4\xa0#,##0.00)",
    "en-NR": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-NU": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-NZ": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-PG": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-PH": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-PK": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-PN": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-PR": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-PW": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-RW": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-SB": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-SC": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-SD": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-SE": "#,##0.00\xa0\xa4",
    "en-SG": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-SH": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-SI": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "en-SL": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-SS": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-SX": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-SZ": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-TC": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-TK": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-TO": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-TT": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-TV": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-TZ": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-UG": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-UM": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-US-POSIX": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-VC": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-VG": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-VI": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-VU": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-WS": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-ZA": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-ZM": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-ZW": "\xa4#,##0.00;(\xa4#,##0.00)",
    eo: "\xa4\xa0#,##0.00",
    es: "#,##0.00\xa0\xa4",
    "es-419": "\xa4#,##0.00",
    "es-AR": "\xa4\xa0#,##0.00;(\xa4\xa0#,##0.00)",
    "es-BO": "\xa4#,##0.00",
    "es-BR": "\xa4#,##0.00",
    "es-BZ": "\xa4#,##0.00",
    "es-CL": "\xa4#,##0.00",
    "es-CO": "\xa4#,##0.00",
    "es-CR": "\xa4#,##0.00",
    "es-CU": "\xa4#,##0.00",
    "es-DO": "\xa4#,##0.00;(\xa4#,##0.00)",
    "es-EA": "#,##0.00\xa0\xa4",
    "es-EC": "\xa4#,##0.00",
    "es-GQ": "#,##0.00\xa0\xa4",
    "es-GT": "\xa4#,##0.00",
    "es-HN": "\xa4#,##0.00",
    "es-IC": "#,##0.00\xa0\xa4",
    "es-MX": "\xa4#,##0.00",
    "es-NI": "\xa4#,##0.00",
    "es-PA": "\xa4#,##0.00",
    "es-PE": "\xa4#,##0.00",
    "es-PH": "#,##0.00\xa0\xa4",
    "es-PR": "\xa4#,##0.00",
    "es-PY": "\xa4#,##0.00",
    "es-SV": "\xa4#,##0.00",
    "es-US": "\xa4#,##0.00",
    "es-UY": "\xa4\xa0#,##0.00;(\xa4\xa0#,##0.00)",
    "es-VE": "\xa4#,##0.00",
    et: "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    eu: "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    ewo: "#,##0.00\xa0\xa4",
    fa: "\u200e\xa4\xa0#,##0.00;\u200e(\xa4\xa0#,##0.00)",
    "fa-AF": "\xa4\xa0#,##0.00;\u200e(\xa4\xa0#,##0.00)",
    ff: "#,##0.00\xa0\xa4",
    "ff-Latn": "#,##0.00\xa0\xa4",
    "ff-Latn-BF": "#,##0.00\xa0\xa4",
    "ff-Latn-CM": "#,##0.00\xa0\xa4",
    "ff-Latn-GH": "#,##0.00\xa0\xa4",
    "ff-Latn-GM": "#,##0.00\xa0\xa4",
    "ff-Latn-GN": "#,##0.00\xa0\xa4",
    "ff-Latn-GW": "#,##0.00\xa0\xa4",
    "ff-Latn-LR": "#,##0.00\xa0\xa4",
    "ff-Latn-MR": "#,##0.00\xa0\xa4",
    "ff-Latn-NE": "#,##0.00\xa0\xa4",
    "ff-Latn-NG": "#,##0.00\xa0\xa4",
    "ff-Latn-SL": "#,##0.00\xa0\xa4",
    fi: "#,##0.00\xa0\xa4",
    fil: "\xa4#,##0.00;(\xa4#,##0.00)",
    fo: "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "fo-DK": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    fr: "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "fr-BE": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "fr-BF": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "fr-BI": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "fr-BJ": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "fr-BL": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "fr-CA": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "fr-CD": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "fr-CF": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "fr-CG": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "fr-CH": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "fr-CI": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "fr-CM": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "fr-DJ": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "fr-DZ": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "fr-GA": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "fr-GF": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "fr-GN": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "fr-GP": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "fr-GQ": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "fr-HT": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "fr-KM": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "fr-LU": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "fr-MA": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "fr-MC": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "fr-MF": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "fr-MG": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "fr-ML": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "fr-MQ": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "fr-MR": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "fr-MU": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "fr-NC": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "fr-NE": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "fr-PF": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "fr-PM": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "fr-RE": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "fr-RW": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "fr-SC": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "fr-SN": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "fr-SY": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "fr-TD": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "fr-TG": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "fr-TN": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "fr-VU": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "fr-WF": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "fr-YT": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    fur: "\xa4\xa0#,##0.00",
    fy: "\xa4\xa0#,##0.00;(\xa4\xa0#,##0.00)",
    ga: "\xa4#,##0.00;(\xa4#,##0.00)",
    "ga-GB": "\xa4#,##0.00;(\xa4#,##0.00)",
    gd: "\xa4#,##0.00;(\xa4#,##0.00)",
    gl: "#,##0.00\xa0\xa4",
    gsw: "#,##0.00\xa0\xa4",
    "gsw-FR": "#,##0.00\xa0\xa4",
    "gsw-LI": "#,##0.00\xa0\xa4",
    gu: "\xa4#,##,##0.00;(\xa4#,##,##0.00)",
    guz: "\xa4#,##0.00;(\xa4#,##0.00)",
    gv: "\xa4#,##0.00",
    ha: "\xa4\xa0#,##0.00",
    "ha-GH": "\xa4\xa0#,##0.00",
    "ha-NE": "\xa4\xa0#,##0.00",
    haw: "\xa4#,##0.00;(\xa4#,##0.00)",
    he: "#,##0.00\xa0\xa4",
    hi: "\xa4#,##,##0.00",
    hr: "#,##0.00\xa0\xa4",
    "hr-BA": "#,##0.00\xa0\xa4",
    hsb: "#,##0.00\xa0\xa4",
    hu: "#,##0.00\xa0\xa4",
    hy: "#,##0.00\xa0\xa4",
    ia: "\xa4\xa0#,##0.00;(\xa4\xa0#,##0.00)",
    id: "\xa4#,##0.00",
    ig: "\xa4#,##0.00;(\xa4#,##0.00)",
    ii: "\xa4\xa0#,##0.00",
    is: "#,##0.00\xa0\xa4",
    it: "#,##0.00\xa0\xa4",
    "it-CH": "#,##0.00\xa0\xa4",
    "it-SM": "#,##0.00\xa0\xa4",
    "it-VA": "#,##0.00\xa0\xa4",
    ja: "\xa4#,##0.00;(\xa4#,##0.00)",
    jgo: "\xa4\xa0#,##0.00",
    jmc: "\xa4#,##0.00",
    jv: "\xa4\xa0#,##0.00",
    ka: "#,##0.00\xa0\xa4",
    kab: "#,##0.00\xa4",
    kam: "\xa4#,##0.00;(\xa4#,##0.00)",
    kde: "\xa4#,##0.00;(\xa4#,##0.00)",
    kea: "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    khq: "#,##0.00\xa4",
    ki: "\xa4#,##0.00;(\xa4#,##0.00)",
    kk: "#,##0.00\xa0\xa4",
    kkj: "\xa4\xa0#,##0.00",
    kl: "\xa4#,##0.00;\xa4-#,##0.00",
    kln: "\xa4#,##0.00;(\xa4#,##0.00)",
    km: "#,##0.00\xa4;(#,##0.00\xa4)",
    kn: "\xa4#,##0.00;(\xa4#,##0.00)",
    ko: "\xa4#,##0.00;(\xa4#,##0.00)",
    "ko-KP": "\xa4#,##0.00;(\xa4#,##0.00)",
    kok: "\xa4#,##0.00;(\xa4#,##0.00)",
    ks: "\xa4\xa0#,##,##0.00",
    ksb: "#,##0.00\xa4",
    ksf: "#,##0.00\xa0\xa4",
    ksh: "#,##0.00\xa0\xa4",
    ku: "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    kw: "\xa4#,##0.00",
    ky: "#,##0.00\xa0\xa4",
    lag: "\xa4\xa0#,##0.00",
    lb: "#,##0.00\xa0\xa4",
    lg: "#,##0.00\xa4",
    lkt: "\xa4\xa0#,##0.00",
    ln: "#,##0.00\xa0\xa4",
    "ln-AO": "#,##0.00\xa0\xa4",
    "ln-CF": "#,##0.00\xa0\xa4",
    "ln-CG": "#,##0.00\xa0\xa4",
    lo: "\xa4#,##0.00;\xa4-#,##0.00",
    lrc: "\xa4\xa0#,##0.00",
    "lrc-IQ": "\xa4\xa0#,##0.00",
    lt: "#,##0.00\xa0\xa4",
    lu: "#,##0.00\xa4",
    luo: "#,##0.00\xa4",
    luy: "\xa4#,##0.00;\xa4-\xa0#,##0.00",
    lv: "#,##0.00\xa0\xa4",
    mas: "\xa4#,##0.00;(\xa4#,##0.00)",
    "mas-TZ": "\xa4#,##0.00;(\xa4#,##0.00)",
    mer: "\xa4#,##0.00;(\xa4#,##0.00)",
    mfe: "\xa4\xa0#,##0.00",
    mg: "\xa4#,##0.00",
    mgh: "\xa4\xa0#,##0.00",
    mgo: "\xa4\xa0#,##0.00",
    mi: "\xa4\xa0#,##0.00",
    mk: "#,##0.00\xa0\xa4",
    ml: "\xa4#,##0.00;(\xa4#,##0.00)",
    mn: "\xa4\xa0#,##0.00",
    mr: "\xa4#,##0.00;(\xa4#,##0.00)",
    ms: "\xa4#,##0.00;(\xa4#,##0.00)",
    "ms-BN": "\xa4#,##0.00;(\xa4#,##0.00)",
    "ms-SG": "\xa4#,##0.00;(\xa4#,##0.00)",
    mt: "\xa4#,##0.00",
    mua: "\xa4#,##0.00;(\xa4#,##0.00)",
    my: "\xa4\xa0#,##0.00",
    mzn: "\xa4\xa0#,##0.00",
    naq: "\xa4#,##0.00",
    nb: "\xa4\xa0#,##0.00",
    "nb-SJ": "\xa4\xa0#,##0.00",
    nd: "\xa4#,##0.00;(\xa4#,##0.00)",
    nds: "\xa4\xa0#,##0.00",
    "nds-NL": "\xa4\xa0#,##0.00",
    ne: "\xa4\xa0#,##0.00",
    "ne-IN": "\xa4\xa0#,##0.00",
    nl: "\xa4\xa0#,##0.00;(\xa4\xa0#,##0.00)",
    "nl-AW": "\xa4\xa0#,##0.00;(\xa4\xa0#,##0.00)",
    "nl-BE": "\xa4\xa0#,##0.00;(\xa4\xa0#,##0.00)",
    "nl-BQ": "\xa4\xa0#,##0.00;(\xa4\xa0#,##0.00)",
    "nl-CW": "\xa4\xa0#,##0.00;(\xa4\xa0#,##0.00)",
    "nl-SR": "\xa4\xa0#,##0.00;(\xa4\xa0#,##0.00)",
    "nl-SX": "\xa4\xa0#,##0.00;(\xa4\xa0#,##0.00)",
    nmg: "#,##0.00\xa0\xa4",
    nn: "#,##0.00\xa0\xa4",
    nnh: "\xa4\xa0#,##0.00",
    nus: "\xa4#,##0.00;(\xa4#,##0.00)",
    nyn: "\xa4#,##0.00",
    om: "\xa4#,##0.00",
    "om-KE": "\xa4#,##0.00",
    or: "\xa4#,##0.00;(\xa4#,##0.00)",
    os: "\xa4\xa0#,##0.00",
    "os-RU": "\xa4\xa0#,##0.00",
    pa: "\xa4\xa0#,##0.00",
    "pa-Arab": "\xa4\xa0#,##0.00",
    "pa-Guru": "\xa4\xa0#,##0.00",
    pl: "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    prg: "\xa4\xa0#,##0.00",
    ps: "\xa4#,##0.00;(\xa4#,##0.00)",
    "ps-PK": "\xa4#,##0.00;(\xa4#,##0.00)",
    pt: "\xa4\xa0#,##0.00",
    "pt-AO": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "pt-CH": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "pt-CV": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "pt-GQ": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "pt-GW": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "pt-LU": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "pt-MO": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "pt-MZ": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "pt-PT": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "pt-ST": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "pt-TL": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    qu: "\xa4\xa0#,##0.00",
    "qu-BO": "\xa4\xa0#,##0.00",
    "qu-EC": "\xa4\xa0#,##0.00",
    rm: "#,##0.00\xa0\xa4",
    rn: "#,##0.00\xa4",
    ro: "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "ro-MD": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    rof: "\xa4#,##0.00",
    root: "\xa4\xa0#,##0.00",
    ru: "#,##0.00\xa0\xa4",
    "ru-BY": "#,##0.00\xa0\xa4",
    "ru-KG": "#,##0.00\xa0\xa4",
    "ru-KZ": "#,##0.00\xa0\xa4",
    "ru-MD": "#,##0.00\xa0\xa4",
    "ru-UA": "#,##0.00\xa0\xa4",
    rw: "\xa4\xa0#,##0.00",
    rwk: "#,##0.00\xa4",
    sah: "#,##0.00\xa0\xa4",
    saq: "\xa4#,##0.00;(\xa4#,##0.00)",
    sbp: "#,##0.00\xa4",
    sd: "\xa4\xa0#,##0.00",
    se: "#,##0.00\xa0\xa4",
    "se-FI": "#,##0.00\xa0\xa4",
    "se-SE": "#,##0.00\xa0\xa4",
    seh: "#,##0.00\xa4",
    ses: "#,##0.00\xa4",
    sg: "\xa4#,##0.00;\xa4-#,##0.00",
    shi: "#,##0.00\xa4",
    "shi-Latn": "#,##0.00\xa4",
    "shi-Tfng": "#,##0.00\xa4",
    si: "\xa4#,##0.00;(\xa4#,##0.00)",
    sk: "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    sl: "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    smn: "#,##0.00\xa0\xa4",
    sn: "\xa4#,##0.00;(\xa4#,##0.00)",
    so: "\xa4#,##0.00;(\xa4#,##0.00)",
    "so-DJ": "\xa4#,##0.00;(\xa4#,##0.00)",
    "so-ET": "\xa4#,##0.00;(\xa4#,##0.00)",
    "so-KE": "\xa4#,##0.00;(\xa4#,##0.00)",
    sq: "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "sq-MK": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "sq-XK": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    sr: "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "sr-Cyrl": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "sr-Cyrl-BA": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "sr-Cyrl-ME": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "sr-Cyrl-XK": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "sr-Latn": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "sr-Latn-BA": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "sr-Latn-ME": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "sr-Latn-XK": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    sv: "#,##0.00\xa0\xa4",
    "sv-AX": "#,##0.00\xa0\xa4",
    "sv-FI": "#,##0.00\xa0\xa4",
    sw: "\xa4\xa0#,##0.00",
    "sw-CD": "\xa4\xa0#,##0.00",
    "sw-KE": "\xa4\xa0#,##0.00",
    "sw-UG": "\xa4\xa0#,##0.00",
    ta: "\xa4#,##0.00;(\xa4#,##0.00)",
    "ta-LK": "\xa4#,##0.00;(\xa4#,##0.00)",
    "ta-MY": "\xa4#,##0.00;(\xa4#,##0.00)",
    "ta-SG": "\xa4#,##0.00;(\xa4#,##0.00)",
    te: "\xa4#,##0.00;(\xa4#,##0.00)",
    teo: "\xa4#,##0.00;(\xa4#,##0.00)",
    "teo-KE": "\xa4#,##0.00;(\xa4#,##0.00)",
    tg: "#,##0.00\xa0\xa4",
    th: "\xa4#,##0.00;(\xa4#,##0.00)",
    ti: "\xa4#,##0.00",
    "ti-ER": "\xa4#,##0.00",
    tk: "#,##0.00\xa0\xa4",
    to: "\xa4\xa0#,##0.00",
    tr: "\xa4#,##0.00;(\xa4#,##0.00)",
    "tr-CY": "\xa4#,##0.00;(\xa4#,##0.00)",
    tt: "#,##0.00\xa0\xa4",
    twq: "#,##0.00\xa4",
    tzm: "#,##0.00\xa0\xa4",
    ug: "\xa4#,##0.00;(\xa4#,##0.00)",
    uk: "#,##0.00\xa0\xa4",
    ur: "\xa4#,##0.00;(\xa4#,##0.00)",
    "ur-IN": "\xa4#,##0.00;(\xa4#,##0.00)",
    uz: "#,##0.00\xa0\xa4",
    "uz-Arab": "\xa4\xa0#,##0.00",
    "uz-Cyrl": "#,##0.00\xa0\xa4",
    "uz-Latn": "#,##0.00\xa0\xa4",
    vai: "\xa4#,##0.00;(\xa4#,##0.00)",
    "vai-Latn": "\xa4#,##0.00;(\xa4#,##0.00)",
    "vai-Vaii": "\xa4#,##0.00;(\xa4#,##0.00)",
    vi: "#,##0.00\xa0\xa4",
    vo: "\xa4\xa0#,##0.00",
    vun: "\xa4#,##0.00",
    wae: "\xa4\xa0#,##0.00",
    wo: "\xa4\xa0#,##0.00",
    xh: "\xa4#,##0.00",
    xog: "#,##0.00\xa0\xa4",
    yav: "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    yi: "\xa4\xa0#,##0.00",
    yo: "\xa4#,##0.00;(\xa4#,##0.00)",
    "yo-BJ": "\xa4#,##0.00;(\xa4#,##0.00)",
    yue: "\xa4#,##0.00;(\xa4#,##0.00)",
    "yue-Hans": "\xa4#,##0.00;(\xa4#,##0.00)",
    "yue-Hant": "\xa4#,##0.00;(\xa4#,##0.00)",
    zgh: "#,##0.00\xa4",
    zh: "\xa4#,##0.00;(\xa4#,##0.00)",
    "zh-Hans": "\xa4#,##0.00;(\xa4#,##0.00)",
    "zh-Hans-HK": "\xa4#,##0.00;(\xa4#,##0.00)",
    "zh-Hans-MO": "\xa4#,##0.00;(\xa4#,##0.00)",
    "zh-Hans-SG": "\xa4#,##0.00;(\xa4#,##0.00)",
    "zh-Hant": "\xa4#,##0.00;(\xa4#,##0.00)",
    "zh-Hant-HK": "\xa4#,##0.00;(\xa4#,##0.00)",
    "zh-Hant-MO": "\xa4#,##0.00;(\xa4#,##0.00)",
    zu: "\xa4#,##0.00;(\xa4#,##0.00)"
};



//////////////////
// WEBPACK FOOTER
// ./~/devextreme/localization/cldr-data/accounting_formats.js
// module id = 1026
// module chunks = 0